var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0038 8.75016L22.0872 4.66683M24.4205 2.3335L22.0872 4.66683L24.4205 2.3335ZM13.2088 13.5452C13.8112 14.1395 14.2901 14.8472 14.6179 15.6274C14.9456 16.4076 15.1158 17.245 15.1187 18.0912C15.1215 18.9375 14.9569 19.776 14.6344 20.5583C14.3118 21.3407 13.8377 22.0516 13.2393 22.65C12.6409 23.2484 11.9301 23.7225 11.1477 24.0451C10.3653 24.3676 9.52682 24.5322 8.68056 24.5294C7.8343 24.5265 6.99695 24.3563 6.21674 24.0285C5.43653 23.7008 4.72886 23.2219 4.13449 22.6195C2.96564 21.4093 2.31887 19.7884 2.33349 18.106C2.34811 16.4236 3.02295 14.8142 4.21265 13.6245C5.40235 12.4348 7.01173 11.76 8.69416 11.7453C10.3766 11.7307 11.9975 12.3775 13.2077 13.5463L13.2088 13.5452ZM13.2088 13.5452L18.0038 8.75016L13.2088 13.5452ZM18.0038 8.75016L21.5038 12.2502L25.5872 8.16683L22.0872 4.66683L18.0038 8.75016Z",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.46d962a3bdaa7e424ed0d276e16041d9.svg";
export { ForwardRef as ReactComponent };